import Icon from './Icon';
import List from './List';
import Show from './Show';
import appRoles from '../../util/roles';

const roles = [
    appRoles.SysAdmin,
];


const name = 'courses';

export default { name, roles, Icon, List, Show };